import axios from 'axios';
import { env } from '../env';

const API_URL = env.apiUrl;

export const loginUser = async (data) => {
  try {
    const response = await axios.post(API_URL+'/usuario/login/', data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    return 400;
  }
}